/**
 * @generated SignedSource<<2038f0bc7e15db406fe181704fe52b53>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type sectionStyleFashionCarouselQuery$data = {
  readonly fashionCarousel: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
          readonly " $fragmentSpreads": FragmentRefs<"magazinesStyleFashionCarouselContentItemContent">;
        };
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "sectionStyleFashionCarouselQuery";
};
export type sectionStyleFashionCarouselQuery$key = {
  readonly " $data"?: sectionStyleFashionCarouselQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"sectionStyleFashionCarouselQuery">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "sectionStyleFashionCarouselQuery",
  "selections": [
    {
      "alias": "fashionCarousel",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "name": "style_fashion_carousel"
          }
        }
      ],
      "concreteType": "Queue",
      "kind": "LinkedField",
      "name": "queue",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "QueueItemConnection",
          "kind": "LinkedField",
          "name": "items",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "QueueItemsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "entityId",
                          "storageKey": null
                        }
                      ],
                      "type": "BaseWithApplicationAndUrlAlias",
                      "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "magazinesStyleFashionCarouselContentItemContent"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "queue(filter:{\"name\":\"style_fashion_carousel\"})"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "f587a6e2e8c131047b8898d69025d272";

export default node;
